import BoxLoader from "../../general/boxLoader";
import EmptyBox from "../../general/emptyBox";
import React from "react";
import AppointmentCardsBoxItem from "./appointmentCardsBox_Item";

type AppointmentCardsBoxProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean
}

const AppointmentsCardsBox = ({
  dataList,
  dataListTitles,
  isRequesting
}: AppointmentCardsBoxProps) => {
  const _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item: any, i: number) => {
    return <AppointmentCardsBoxItem item={item} dataListTitles={dataListTitles} key={i}/>
  })
  return (
    <div>
      {isRequesting ? <BoxLoader/> : _dataList ? _dataList : <EmptyBox content={''} className={''} children={''}/>}
    </div>
  )
}

export default AppointmentsCardsBox;